<!-- Chat Modal -->
<div class="modal fade" id="chat-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content pb-0">
      <form action="#" id="chatModal">
        <div class="modal-header bg-color" *ngIf="job">
          <h5 class="modal-title">
            {{ commentType === 'job' ? 'Job' : 'Accounting' }} Comments: {{ job.customer_name }} {{ job.number }} -
            {{ job.main_job_dept }}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body p-0">
          <div class="chat-in-modal">
            <div class="chat-history scrollbar" id="chatBlock">
              <ul>
                <li *ngFor="let msg of messages" class="{{ msg.user_id == userId ? 'my-msg' : 'other-msg' }}">
                  <div class="msg-data">
                    {{ msg.user_name }},
                    {{ msg.created_date }}
                  </div>
                  <div class="msg">
                    {{ msg.comment }}
                  </div>
                </li>
              </ul>
              <div *ngIf="!messagesLoaded" class="col-sm-12 text-center">
                <div class="spinner-border m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div class="msg-text">
              <div class="inner d-flex justify-content-between align-items-center">
                <div class="type-fild">
                  <input
                  id="chat-modal-text-input"
                    autofocus
                    #inputField
                    type="text"
                    [(ngModel)]="newMessage"
                    name="newMessage"
                    class="form-control"
                    placeholder="Enter {{ commentType ? 'job' : 'accounting' }} notes here..." />
                </div>
                <div class="right-option">
                  <a href="javascript:;" class="emoji"><i class="far fa-smile"></i></a>
                  <button type="submit" class="send" (click)="sendMessage()"><i class="fas fa-paper-plane"></i></button>
                </div>
              </div>
              <button
                class="btn btn-circle-sm btn-printer"
                (click)="print(job.id, commentType)"
                data-toggle="modal"
                data-target="#pdf-comments"
                data-dismiss="modal">
                <i class="fas fa-print"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Chat Modal End-->
